function submitFormJob(token) {
    var that = $('#js-job');
    $('.js-form-group').removeClass('has-error');
    that.find('button[type="submit"]').prop('disabled', 'disabled');
    var data = new FormData(that[0]);
    data.append('action', 'job_form');

    $.ajax({
        url: ajaxurl,
        data: data,
        processData: false,
        contentType: false,
        type: 'POST',
        // beforeSend: function() {
        //     $('.js-progress').addClass('animated');
        // },
        success:function(data){
            // console.log(data);
            that.find('button[type="submit"]').prop('disabled', 'disabled');
            $('.js-error-msg').hide();
            $('.js-valid-msg').show();
            // $('.js-progress').removeClass('animated');
            that.find('#blur').css({
                'pointer-events': 'none',
                'filter': 'blur(1px)',
                'opacity': '0.2'
            });
        },
        error: function(xhr, status, error) {
            // console.log(xhr.responseJSON);
            Object.keys(xhr.responseJSON).map(function(key) {
                $('#' + key).parents('.js-form-group').addClass('has-error');
            });
            that.find('button[type="submit"]').prop('disabled', false);
            $('.js-error-msg').fadeIn();
            $window.scrollTop(0);
            // $('.js-progress').removeClass('animated');
        }
    });
}

$(function() {
    $('#js-job #submit').on('click', function(event){
        event.preventDefault();
        validateFields('#js-job', 'validate_fields_job');
    });
    $('.input-file').on('change', function() {
        if($(this).val() == ''){
            var label = $(this).next('.label').find('.filename').data('label');
            $(this).next('.label').find('.filename').html(label);
        }
        else {
            var file = $(this)[0].files[0].name;
            $(this).next('.label').find('.filename').html(file);
        }
    });
});

